export default "__VITE_ASSET__BRAlRoij__"